import { render, staticRenderFns } from "./BaseSkill.vue?vue&type=template&id=2e745c9a&scoped=true"
import script from "./BaseSkill.vue?vue&type=script&lang=js"
export * from "./BaseSkill.vue?vue&type=script&lang=js"
import style0 from "./BaseSkill.vue?vue&type=style&index=0&id=2e745c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e745c9a",
  null
  
)

export default component.exports